const CptName = 'ComOriginSource'
function formatData (node) {
  // console.dir(node);
  return {
    data: {
      value: node.innerHTML
    },
    cpt: CptName
  }
}

export default {
  name: 'origin_source',
  formatData
}